import Alpine from 'alpinejs';
import { AlpineComponentTryba } from '../../alpine/include/global'
import { limitInputLength } from '../../alpine/include/magics'
import { sendEventDataLayer, sendLpForm } from '../../alpine/include/taggage'
import {
    activateFloatingLabel,
    addQwamplifyToFormData,
    addUtmToFormData,
    replaceFormNameByZero
} from '../../helpers/form'
import { ApiError, send } from '../../helpers/api'
import { AutocompleteSelectedEvent } from '../../../components/newAutocomplete/types'

const NAME_REGEX = /^[A-Za-z\-ÀÂÄÉÈÊËÎÏÌÍĮĪÔÖÒÓÕÛÙÜÇĆČàâäéèêëîïìíįīôöòóõûùüçćč\s]*$/;
const EMAIL_REGEX = /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/;
const PHONE_REGEX = /^(?:\d\d\s){4}(?:\d\d)$|^(?:\+33\d\s)(?:\d\d\s){3}(?:\d\d)$/;
const ZIP_REGEX = /^\d{5}\s+[\p{L}\d'’ .-]+$/u;

document.addEventListener('alpine:init', () => {
    // @ts-ignore
    Alpine.data('simpleVerandaCornerForm', (form: HTMLFormElement, floatingLabels: boolean): AlpineComponentTryba => {
        return {
            confirmation: false,
            loading: false,
            disabled: true,
            errors: {
                firstname: '',
                lastname: '',
                zip: '',
                email: '',
                phone: '',
            },
            firstname: {
                ['@input.debounce.100ms'](): void {
                    this._validateNameField(this.$el, 'firstname');
                    this._limitInputLength(this.$el);
                    this._checkValidation();
                },
                ['@focus'](): void {
                    this._activateFloatingLabel(this.$el, true);
                },
                ['@blur'](): void {
                    this._activateFloatingLabel(this.$el, false);
                },
            },
            lastname: {
                ['@input.debounce.100ms'](): void {
                    this._validateNameField(this.$el, 'lastname');
                    this._limitInputLength(this.$el);
                    this._checkValidation();
                },
                ['@focus'](): void {
                    this._activateFloatingLabel(this.$el, true);
                },
                ['@blur'](): void {
                    this._activateFloatingLabel(this.$el, false);
                },
            },
            zip: {
                ['@input.debounce.100ms'](): void {
                    this._validateZipField(this.$el, 'zip');
                    this._checkValidation();
                },
                ['@focus'](): void {
                    this._activateFloatingLabel(this.$el, true);
                },
                ['@blur'](): void {
                    this._activateFloatingLabel(this.$el, false);
                },
            },
            email: {
                ['@input.debounce.100ms'](): void {
                    this._limitInputLength(this.$el);
                    this._checkValidation();
                },
                ['@focus'](): void {
                    this._activateFloatingLabel(this.$el, true);
                },
                ['@blur'](): void {
                    this._activateFloatingLabel(this.$el, false);
                    this._validateEmailField(this.$el);
                    this._checkValidation();
                },
            },
            phone: {
                ['@input.debounce.100ms'](): void {
                    this._validatePhoneField(this.$el, 'phone');
                    this._checkValidation();
                },
                ['@focus'](): void {
                    this._activateFloatingLabel(this.$el, true);
                },
                ['@blur'](): void {
                    this._activateFloatingLabel(this.$el, false);
                },
            },
            submit: {
                ['@click.prevent'](): void {
                    this._submit();
                },
            },
            zipMask(input: string): string {
                if (input.includes(' ')) {
                    return '';
                } else if (new RegExp(/^\d/).test(input)) {
                    return '99999';
                } else {
                    return '';
                }
            },
            phoneMask(input: string): string {
                return new RegExp(/^\+3?3?/).test(input) ? '+339 99 99 99 99' : '09 99 99 99 99'
            },
            onAutocompleteSelected(event: AutocompleteSelectedEvent): void {
                this._validateZipField(event.detail.input, 'zip');
                this._checkValidation();
            },
            _validateNameField(element: HTMLInputElement, name: string): void {
                const value = element.value.trim();
                if (this.errors[name] === undefined) {
                    this._displayTick(element, false);
                    return;
                }

                if (value === '') {
                    this.errors[name] = 'Ce champ est requis';
                    this._displayTick(element, false);
                    return;
                }

                if (!new RegExp(NAME_REGEX).test(value)) {
                    this.errors[name] = 'Ce champ ne doit pas contenir de chiffres.';
                    this._displayTick(element, false);
                    return;
                }

                this.errors[name] = '';
                this._displayTick(element, true);
            },
            _validateEmailField(element: HTMLInputElement): void {
                const name = 'email';
                const value = element.value.trim();
                if (this.errors[name] === undefined) {
                    this._displayTick(element, false);
                    return;
                }

                if (value === '') {
                    this.errors[name] = 'Ce champ est requis';
                    this._displayTick(element, false);
                    return;
                }

                if (!new RegExp(EMAIL_REGEX).test(value)) {
                    this.errors[name] = 'Cet email n\'est pas valide.';
                    this._displayTick(element, false);
                    return;
                }

                this.errors[name] = '';
                this._displayTick(element, true);
            },
            _validateRequiredField(element: HTMLInputElement, name: string): void {
                const value = element.value.trim();
                if (this.errors[name] === undefined) {
                    this._displayTick(element, false);
                    return;
                }

                if (value === '') {
                    this.errors[name] = 'Ce champ est requis';
                    this._displayTick(element, false);
                    return;
                }

                this.errors[name] = '';
                this._displayTick(element, true);
            },
            _validatePhoneField(element: HTMLInputElement, name: string): void {
                const value = element.value.trim();
                if (this.errors[name] === undefined) {
                    this._displayTick(element, false);
                    return;
                }

                if (value === '') {
                    this.errors[name] = 'Ce champ est requis';
                    this._displayTick(element, false);
                    return;
                }


                if (!new RegExp(PHONE_REGEX).test(value)) {
                    this.errors[name] = 'Le numéro doit être composé de 10 chiffres.';
                    this._displayTick(element, false);
                    return;
                }

                this.errors[name] = '';
                this._displayTick(element, true);
            },
            _validateZipField(element: HTMLInputElement, name: string): void {
                const value = element.value.trim();
                if (this.errors[name] === undefined) {
                    this._displayTick(element, false);
                    return;
                }

                if (value === '') {
                    this.errors[name] = 'Ce champ est requis';
                    this._displayTick(element, false);
                    return;
                }


                if (!new RegExp(ZIP_REGEX).test(value)) {
                    this.errors[name] = 'Le champs doit être composé du code postal et de la ville.';
                    this._displayTick(element, false);
                    return;
                }

                this.errors[name] = '';
                this._displayTick(element, true);
            },
            _limitInputLength (element: HTMLInputElement): void {
                const maxLength = element.maxLength >= 0 ? element.maxLength : 150
                limitInputLength(element, maxLength);
            },
            _displayTick(element: HTMLInputElement, show: boolean): void {
                const check = form.querySelector(`[data-js-check-validate="${element.id}"]`);
                if (!check) {
                    return;
                }

                if (show) {
                    check.classList.remove('opacity-0');
                    return;
                }

                check.classList.add('opacity-0');
            },
            _activateFloatingLabel(element: HTMLElement, activate: boolean): void {
                if (!floatingLabels) {
                    return;
                }

                activateFloatingLabel(element, activate)
            },
            _checkValidation(): void {
                const allFilled = [...form.querySelectorAll<HTMLInputElement>('input[name*="firstname"], input[name*="lastname"], input[name*="zip"], input[name*="phone"], input[name*="email"]')].every((input: HTMLInputElement) => input.value !== '')
                // const projectTypesChecked = form.querySelector('input[name*="projectTypes"]:checked') !== null;
                const hasErrors = ! Object.values(this.errors).every(v => v === '');

                this.disabled = !(allFilled && !hasErrors);
            },
            _submit() {
                this.$nextTick(async () => {
                    if (this.disabled) {
                        return;
                    }

                    this.disabled = true;
                    this.loading = true;
                    const isLandingPage = document.body.dataset.type === 'landingPage';
                    if (isLandingPage) {
                        sendEventDataLayer('page', "", "", '/landing/form/confirmation')
                    }
                    if (form) {
                        replaceFormNameByZero(form);
                        const formData = new FormData(form);
                        addUtmToFormData(formData, form.name);
                        addQwamplifyToFormData(formData, form.name);

                        if (!floatingLabels) {
                            form.submit();
                            return;
                        }

                        try {
                            await send(formData, isLandingPage ? form.action + '?is_landing_page=true' : form.action);
                            this.confirmation = true;
                            this.loading = false;
                            this.disabled = false;
                            if (isLandingPage) {
                                form.setAttribute('data-tracking', 'confirmation-landing-devis-express')
                            } else {
                                form.setAttribute('data-tracking', 'confirmation-devis-express')
                            }
                            window.localStorage.removeItem('utm_source');
                            window.localStorage.removeItem('utm_campaign');
                            window.localStorage.removeItem('qwp_id');
                        } catch (e: unknown) {
                            const err = e as ApiError;
                            Object.keys(this.errors).forEach(key => { this.errors[key] = ''; });
                            Object.keys(err).forEach(k => {
                                this.errors[k] = err[k];
                                const element = form.querySelector(`[x-bind="${k}"]`);
                                if (element) {
                                    this._displayTick(element, false);
                                }
                            })
                            this.confirmation = false;
                            this.loading = false;
                            this.disabled = false;
                        } finally {
                            this.disabled = false;
                            //Send to data Layer confirmation page from express form
                            const body = document.querySelector('body');
                            if (body) {
                                const pageDataType = body.getAttribute('data-type');
                                if (pageDataType) {
                                    sendLpForm({ slot1: pageDataType, slot2: 'confirmation' }, { categoryName: pageDataType })
                                    sendEventDataLayer('click', pageDataType, form.name, this.currentStepIndex + 2)
                                }
                            }
                        }
                    }
                });
            },
        };
    });
});
